module.exports = __webpack_public_path__ + "0e6204424504bf93f7013456c0e0f89f.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/eldar-preview.webm
// module id = 631
// module chunks = 0